/**
 * @deprecated Use new API from entities if it is related to entities
 * or from shared/api for common purpose
 */

import axios, {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';

import { API_URL } from '@/shared/config';
import { logger } from '@/shared/services/logger';
import { ErrorResponse } from '@/domain';
import { APP_ROUTES } from '@/utils_legacy/routes';

logger.debug('API_URL:', API_URL);

const createAxiosInstance = ({
  token,
  customUrl,
  navigate,
  onNext,
}: {
  token?: string;
  customUrl?: string;
  navigate?: (path: string) => void;
  onNext?: () => void;
}): AxiosInstance => {
  const axiosInstance: AxiosInstance = axios.create({
    baseURL: customUrl || API_URL,
    headers: {
      'X-App-Version': '2.5.0', // let's keep it hardcoded for now
    },
  });

  axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    },
    (error: AxiosError): Promise<AxiosError> => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse): AxiosResponse => response,
    (error: AxiosError): Promise<AxiosError> => {
      if (typeof window === 'undefined') {
        return Promise.reject(error);
      }

      if (error.response && error.response.status === 409) {
        const data: ErrorResponse = error.response.data as ErrorResponse;
        switch (data.m) {
          case 'e_user_not_registered':
            if (onNext) {
              onNext();
            } else if (navigate) {
              navigate(APP_ROUTES.UserInfo);
            } else {
              window.location.href = APP_ROUTES.UserInfo;
            }
            break;
          case 'e_vpn':
            window.location.href = APP_ROUTES.ErrorVPN;
            break;
          case 'e_banned':
            window.location.href = `${APP_ROUTES.ErrorBanned}?banId=${data.info.ban.id}&userId=${data.info.ban.user_id}&until=${data.info.ban.until}`;
            break;
        }
        console.error(error.response);
      } else if (error.response && error.response.status === 401) {
        window.location.href = APP_ROUTES.Login;
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default createAxiosInstance;
